import React from "react"
import parse from "html-react-parser"
import PropTypes from "prop-types"
import Typography from "@material-ui/core/Typography"
import { transformLink } from "../../../helpers"
import { CoreHeadingBlockPreview } from "./queries"

export const CoreHeadingBlock = ({ attributes }) => {
  const {
    content,
    anchor,
    level,
    className,
    textColor,
    backgroundColor,
  } = attributes

  if (content === "") return null

  // WP core no longer exposes a `textAlign` attribute for the heading block;
  // it's applied via the typography style support as a `has-text-align-*` class.
  const textAlignMatch = className && className.match(/has-text-align-(\S+)/)
  const textAlign = textAlignMatch ? textAlignMatch[1] : ""

  return (
    <React.Fragment>
      {anchor !== "" && <a id={`${anchor}`}></a> // eslint-disable-line
      }
      <Typography
        component={level !== "" ? `h${level}` : "h2"}
        variant={level !== "" ? `h${level}` : "h2"}
        color="initial"
        align={textAlign !== "" ? textAlign : "left"}
        className={className}
        data-override-color={textColor !== "" ? textColor : "initial"}
        data-override-background={
          backgroundColor !== "" ? backgroundColor : "initial"
        }
      >
        {parse(content !== null ? content : "", { transform: transformLink })}
      </Typography>
    </React.Fragment>
  )
}

CoreHeadingBlock.propTypes = {
  attributes: PropTypes.object.isRequired,
}

export { CoreHeadingBlockPreview }
